import classNames from 'classnames';
import { ElementType, ReactNode } from 'react';

type Props = {
  as?: ElementType;
  children: ReactNode;
  spacing?: 1 | 2 | 3 | 4;
  className?: string;
};

export const VerticalSpacing = ({ as: Component = 'div', children, spacing = 2, className }: Props) => (
  <Component
    className={classNames('d-flex flex-column', className, {
      'row-gap-1': spacing === 1,
      'row-gap-2': spacing === 2,
      'row-gap-3': spacing === 3,
      'row-gap-4': spacing === 4,
    })}
  >
    {children}
  </Component>
);
